// extracted by css-extract-rspack-plugin
export default {"marginSidebar":"Layout__marginSidebar--_CHy7","main":"Layout__main--vOaqf","tmMainContentsSp":"Layout__tmMainContentsSp--ox3Nh"};